import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSmoothScroll from "v-smooth-scroll";

// Core theme JS
import "./template/js/scripts";

// Core theme CSS (includes Bootstrap)
import "./template/css/styles-agency.css";
import "./template/css/styles.css";

createApp(App)
  .use(store)
  .use(router)
  .use(VueSmoothScroll, {
    duration: 1000,
  })
  .mount("#app");
